// Common components
import PConfirmButton from '@/common/buttons/PConfirmButton.js'
import { PontotelBotao, PontotelBotaoIcone } from '@Lar21/imaginii-web-components/lib/vue'
import { CatalogoEmpregado } from '@next/modulos/estrutura-de-ponto-da-empresa/empregado'
import { CatalogoEmpregador } from '@next/modulos/estrutura-de-ponto-da-empresa/empregador'
import { CatalogoLocalDeTrabalho } from '@next/modulos/estrutura-de-ponto-da-empresa/local-de-trabalho'
import { CatalogoMotivoPadrao } from '@next/modulos/estrutura-de-ponto-da-empresa/motivo-padrao'
import { CatalogoGrupoDeLocaisDeTrabalho } from '@next/modulos/governanca/grupo-de-locais-de-trabalho'
import { CatalogoPerfilDePermissao } from '@next/modulos/governanca/perfil-de-permissao'
import { CatalogoRegraDeCalculo } from '@next/modulos/folha-de-ponto/regra-de-calculo'
import { CatalogoUsuario } from '@next/modulos/governanca/usuario'
import PCheckbox from '@/common/inputs/PCheckbox.vue'
import PCheckboxTextField from '@/common/inputs/PCheckboxTextField.vue'
import PDatePicker from '@/common/date/PDatePicker.vue'
import PMultiSelectLegado from '@/common/selectors/PMultiSelectLegado.vue'
import PontotelSeletor from '@/common/selectors/PontotelSeletorInternacionalizado.vue'
import PRadio from '@/common/inputs/PRadio.vue'
import PTextField from '@/common/inputs/PTextField.vue'
import PTextFieldLegado from '@/common/inputs/PTextFieldLegado.vue'
import PTimeCountField from '@/common/inputs/PTimeCountField.vue'
import PTimeField from '@/common/inputs/PTimeField.vue'
import InputCampoTemporal from '@/common/inputs/InputCampoTemporal.vue'
import PModal from '@/common/modal/PModal.vue'
import PSelectLegado from '@/common/selectors/PSelectLegado.vue'
import TransitionExpand from '@/common/transitions/Expand.vue'
import SmartTable from '@/common/SmartTable/SmartTable.vue'
import DBLabel from '@/common/SmartTable/DBLabel.vue'
import TableRow from '@/common/SmartTable/TableRow.vue'
import RadioSlider from '@/common/Tabs/RadioSlider.vue'
import PInputHourMinute from '@/common/inputs/PInputHourMinute.vue'
import Accordion from '@/common/VueAccordion.vue'
import Validate from '@/common/validations/Validate.vue'
import Slider from '@/common/inputs/Slider.vue'
import SkeletonBox from '@/common/Skeleton.vue'
import IconeSVG from '@/common/IconeSVG.vue'
import PChipDeStatus from '@/common/PChipDeStatus.vue'
import GraficoDeBarra from "src/common/graficos/GraficoDeBarra/GraficoDeBarra.vue"

const globalComponents = [
  ['Validate', Validate],
  ['Accordion', Accordion],
  ['PontotelBotao', PontotelBotao],
  ['PontotelBotaoIcone', PontotelBotaoIcone],
  ['PontotelSeletor', PontotelSeletor],
  ['CatalogoEmpregado', CatalogoEmpregado],
  ['CatalogoEmpregador', CatalogoEmpregador],
  ['CatalogoLocalDeTrabalho', CatalogoLocalDeTrabalho],
  ['CatalogoMotivoPadrao', CatalogoMotivoPadrao],
  ['CatalogoGrupoDeLocaisDeTrabalho', CatalogoGrupoDeLocaisDeTrabalho],
  ['CatalogoPerfilDePermissao', CatalogoPerfilDePermissao],
  ['CatalogoUsuario', CatalogoUsuario],
  ['CatalogoRegraDeCalculo', CatalogoRegraDeCalculo],
  ['PConfirmButton', PConfirmButton],
  ['PCheckbox', PCheckbox],
  ['PCheckboxTextField', PCheckboxTextField],
  ['PDatePicker', PDatePicker],
  ['PMultiSelectLegado', PMultiSelectLegado],
  ['PRadio', PRadio],
  ['PTextField', PTextField],
  ['PTextFieldLegado', PTextFieldLegado],
  ['PTimeCountField', PTimeCountField],
  ['PTimeField', PTimeField],
  ['InputCampoTemporal', InputCampoTemporal],
  ['PInputHourMinute', PInputHourMinute],
  ['PModal', PModal],
  ['PSelectLegado', PSelectLegado],
  ['Slider', Slider],
  ['TransitionExpand', TransitionExpand],
  ['RadioSlider', RadioSlider],
  ['SmartTable', SmartTable],
  ['DBLabel', DBLabel],
  ['TableRow', TableRow],
  ['SkeletonBox', SkeletonBox],
  ['IconeSVG', IconeSVG],
  ['PChipDeStatus', PChipDeStatus],
  ['GraficoDeBarra', GraficoDeBarra]
]

export const installGlobalComponents = (app) => {
  globalComponents.forEach(([name, component]) => {
    app.component(name, component)
  })
}
